export const startingGold = {
    Cleric: { dietype: 6, dienumber: 3, multiplier: 10, range: "30-180" },
    Druid: { dietype: 6, dienumber: 3, multiplier: 10, range: "30-180" },
    Fighter: { dietype: 4, dienumber: 5, multiplier: 10, range: "50-200" },
    Paladin: { dietype: 4, dienumber: 5, multiplier: 10, range: "50-200" },
    Ranger: { dietype: 4, dienumber: 5, multiplier: 10, range: "50-200" },
    'Magic-User': { dietype: 4, dienumber: 2, multiplier: 10, range: "20-80" },
    Illusionist: { dietype: 4, dienumber: 2, multiplier: 10, range: "20-80" },
    Thief: { dietype: 6, dienumber: 2, multiplier: 10, range: "20-120" },
    Assassin: { dietype: 6, dienumber: 2, multiplier: 10, range: "20-120" },
    Monk: { dietype: 4, dienumber: 5, multiplier: 1, range: "5-20" }
}